import React from 'react';
import { connect } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import Api from '../../api/Api.js';
import ReportEndpoints from '../../api/ReportEndpoints';
import { store } from '../../redux/store';
import { SET_REPORT_LIST } from '../../redux/types';
import { push } from 'connected-react-router';
import moment from 'moment';
import { Link } from 'react-router-dom';

import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/RemoveRedEye';
import CopyIcon from '@material-ui/icons/FileCopy';
import PlayIcon from '@material-ui/icons/PlayArrow';
import DataTable from '../../components/Table/DataTable';
import { cleanReportName } from '../../helpers';
import LoadingModal from '../../components/Modal/LoadingModal';
import SuccessModal from '../../components/Modal/SuccessModal';
import ErrorModal from '../../components/Modal/ErrorModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScaleLeft } from '@fortawesome/pro-solid-svg-icons';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Report Name",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Last Run",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class SearchReports extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/report/view/' + row[0]))
    };

    UNSAFE_componentWillMount() {
        Api.get(ReportEndpoints.list).then(({ data }) => store.dispatch({ type: SET_REPORT_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (
            <DataTable
                title={"Search Reports"}
                data={
                    this.props.reports
                        .map(rep => [rep.id, cleanReportName(rep.name), moment(rep.lastrun).format('YYYY-MM-DD HH:mm')])
                }
                columns={columns}
                options={this.options}
                rowPointers
            />
        );
    }
}


const columnsAdmin = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Report Name",
        options: {
            filter: false,
            sort: true,
        }
    },
    {
        name: "Last Run",
        options: {
            filter: false,
            sort: true,
        }
    },
    {
        name: "Connection",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Weight",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Actions",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    }
];

class SearchReportsAdmin extends React.Component {

    state = {
        runnningReport: false,
        success: false,
        error: false
    }

    UNSAFE_componentWillMount() {
        Api.get(ReportEndpoints.list).then(({ data }) => store.dispatch({ type: SET_REPORT_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (<>
            <DataTable
                title={"Search Reports"}
                data={
                    this.props.reports
                        .map(rep => [rep.id, 
                        cleanReportName(rep.name), 
                        rep.lastrun ? moment(rep.lastrun).format('YYYY-MM-DD HH:mm') : 'Never', 
                        rep.connection_string,
                        <span key={rep.id}>{`${rep.weight}/${rep.connection_max_weight}`} <FontAwesomeIcon icon={faBalanceScaleLeft} /></span>,
                        [
                            <Tooltip key="edit" title="Edit"><IconButton color="primary" component={Link} to={`/reports/edit/${rep.id}`}><EditIcon /></IconButton></Tooltip>,
                            <Tooltip key="view" title="View"><IconButton component={Link} to={`/reports/view/${rep.id}`}><ViewIcon /></IconButton></Tooltip>,
                            <Tooltip key="copy" title="Copy"><IconButton component={Link} to={`/reports/copy/${rep.id}`}><CopyIcon /></IconButton></Tooltip>,
                            <Tooltip key="run" title="Run Report Now">
                                <IconButton
                                    color="secondary"
                                    onClick={() => {
                                        this.setState({ runnningReport: true }, () => {
                                            Api.get(ReportEndpoints.runNow, { report_id: rep.id })
                                                .then(() => {
                                                    this.setState({ runnningReport: false, success: true })
                                                })
                                                .catch(() => {
                                                    this.setState({ runnningReport: false, error: true })
                                                })
                                        })
                                    }}
                                >
                                    <PlayIcon />
                                </IconButton>
                            </Tooltip>
                        ]
                        ])
                }
                columns={columnsAdmin}
            />
            <LoadingModal open={this.state.runnningReport} />

            <SuccessModal open={this.state.success} close={() => this.setState({ success: false })}>
                Running Report Now!
            </SuccessModal>

            <ErrorModal open={this.state.error} close={() => this.setState({ error: false })}>
                Uh Oh... There was an error while trying to run your report...
            </ErrorModal>
        </>
        );
    }
}

const SearchReportsRolePicker = (props) => {
    if (props.role && props.role.toLowerCase() === 'admin') {
        return <SearchReportsAdmin {...props} />
    } else {
        return <SearchReports {...props} />
    }
}

const mapStateToProps = (state) => ({ reports: state.reports.list, role: ((state.user || { role: { role: null }}).role || { role1: null }).role1 })

export default connect(mapStateToProps)(SearchReportsRolePicker);